<template>
  <a
    :aria-label="starRatingText + ', average rating for this product'"
    class="rfp-rr-star-rating-product-173-or"
    @click="callToActionRatingsTab"
  >
    <vue-star-rating
      :increment="starRatingIncrementValue"
      :max-rating="starRatingMaxRatingValue"
      :inactive-color="starRatingInactiveColor"
      :active-color="starRatingActiveColor"
      :star-size="starRatingStarSize"
      :rating="overallRating"
      :read-only="true"
      :show-rating="false"
    >
    </vue-star-rating>
    <span
      class="rfp-avg-rating-or"
      itemprop="aggregateRating"
      itemscope
      itemtype="https://schema.org/AggregateRating"
    >
      <meta itemprop="ratingValue" :content="ratingValue" />
      <meta itemprop="bestRating" content="5" />
      <meta itemprop="ratingCount" :content="ratingCount" />
      {{ starRatingText }}
    </span>
  </a>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import VueStarRating from '../rfp-ratings-star/Plugins/rfp-ratings-star.vue';

export default {
  name: 'rfp-ratings-star-rating-product',
  components: {
    VueStarRating,
  },
  props: {
    ratingValue: {
      type: Number,
      required: true,
    },
    ratingCount: {
      type: Number,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    counts: {
      type: Number,
      required: false,
    },
    starRatingText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      overallRating: this.rating,
    };
  },
  created() {
    this.autoFocusRatingsTab();
    eventBus.on('overallRatingTransferToComponent', () => {
      this.transferOverallRatings();
    });
  },
  methods: {
    callToActionRatingsTab() {
      this.$scrollTo('#refapp-tabs-titles');
      eventBus.emit('focus-ratings-tab');
    },
    autoFocusRatingsTab() {
      /* istanbul ignore next */
      if (window.location.hash === '#ratings') {
        /* istanbul ignore next */
        setTimeout(function () {
          eventBus.emit('focus-ratings-tab');
          window.location.hash = '#ratings';
          this.$scrollTo('#ratings');
        }, 1000);
      }
    },
    transferOverallRatings() {
      eventBus.emit('overallRatingTransfer', this.overallRating);
    },
  },
};
</script>
